import { sum } from 'lodash'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import MemberActivityByDevice from './MemberActivityByDevice'
import MemberActivityByOS from './MemberActivityByOS'
import messages from './messages'

const MOBILE_DEVICES_VALUES = new Set(['android', 'ios'])

export const formatActivityByDevice = (data: any, intl: any) => {
  if (data.length === 0) return { byDeviceData: [] }
  const deviceTypeCounts = {
    desktop: [],
    mobile: []
  }

  data.forEach((item: any) => {
    if (MOBILE_DEVICES_VALUES.has(Object.keys(item)[0].toLowerCase())) {
      // @ts-expect-error
      deviceTypeCounts.mobile.push(Object.values(item)[0])
    } else {
      // @ts-expect-error
      deviceTypeCounts.desktop.push(Object.values(item)[0])
    }
  })

  const formattedData = [
    {
      name: intl.formatMessage(messages.userActivityDeviceChartLabelDesktop),
      value: sum(deviceTypeCounts.desktop)
    },
    {
      name: intl.formatMessage(messages.userActivityDeviceChartLabelMobile),
      value: sum(deviceTypeCounts.mobile)
    }
  ]

  formattedData.forEach((item, index, object) => {
    if (item.value === 0) {
      object.splice(index, 1)
    }
  })

  const hasMobile = formattedData.length > 1

  if (!hasMobile)
    formattedData.push({ name: intl.formatMessage(messages.userActivityDeviceChartLabelMobile), value: 0 })

  return { byDeviceData: formattedData, hasMobile: hasMobile }
}

export const formatDataByOs = (data: any, hasMobile: any, intl: any) => {
  if (data.length === 0) return []
  const osData = data.map((item: any) => {
    return {
      name: Object.keys(item)[0],
      value: Object.values(item)[0]
    }
  })

  if (!hasMobile) osData.push({ name: intl.formatMessage(messages.userActivityDeviceChartLabelMobile), value: 0 })
  return osData
}
function DeviceMetricsSection(props: any) {
  const intl = useIntl()

  const { deviceMetrics } = props
  const { byDeviceData, hasMobile } = formatActivityByDevice(deviceMetrics, intl)
  const byOsData = formatDataByOs(deviceMetrics, hasMobile, intl)

  return (
    <div className="analytics-section">
      <div className="device-metrics sub-section-wrapper">
        <MemberActivityByDevice byDeviceData={byDeviceData} />
        <div className="divider" />
        <MemberActivityByOS byOSData={byOsData} />
      </div>
    </div>
  )
}

DeviceMetricsSection.displayName = 'DeviceMetricsSection'

DeviceMetricsSection.propTypes = {
  deviceMetrics: PropTypes.array.isRequired
}

export default DeviceMetricsSection
